// Chapter 1 of the detective game: "승화" (see Detective.js).
// Everything the player reads lives here; Detective.js only knows how to play it.

const n = (text) => ({ who: 'narr', text });
const me = (text) => ({ who: 'me', text });
const say = (who, text) => ({ who, text });

export const META = {
  id: 'ch1',
  number: 1,
  hanja: '昇華',
  name: '승화',
  subtitle: '412호 저온실 사건',
  tagline: '흔적 없이 사라지는 것은 없다.',
  saveKey: 'detective_progress',
  startLoc: 'office',
  // The in-game clock runs on clues found, in minutes from midnight.
  clock: { start: 150, end: 340, days: ['새벽'], limit: '기한 06:00' },
};

export const SPEAKERS = {
  me: { name: '서지안', title: '형사', tone: 'me' },
  boss: { name: '박 반장', title: '강력2팀장', tone: 'gray' },
  dean: { name: '학과장', title: '화학과', tone: 'gray' },
  taeo: { name: '민태오', title: '박사과정', tone: 'green' },
  serin: { name: '권세린', title: '박사후연구원', tone: 'violet' },
  mikyung: { name: '오미경', title: '테크니션', tone: 'orange' },
  dain: { name: '이다인', title: '석사과정', tone: 'rose' },
  guard: { name: '이만석', title: '야간 경비원', tone: 'amber' },
};

export const CLUES = {
  corpse: {
    name: '문 안쪽의 긁힌 자국',
    kind: '물증',
    text: '교수는 문 바로 안쪽에 쓰러져 있었다. 문 안쪽에 긁힌 자국, 깨진 손톱 세 개. 손끝 말고는 외상 없음. 사망 추정 00:30~01:00.',
  },
  dryice: {
    name: '저온실의 드라이아이스',
    kind: '물증',
    text: '뚜껑이 벗겨진 상자 세 개. 문에서는 보이지 않는 맨 안쪽 선반 밑에 있었다. 문에는 「드라이아이스 반입 금지」 경고문이 붙어 있다. 가스는 바닥에 고인다.',
  },
  pin: {
    name: '빠진 고정핀',
    kind: '물증',
    text: '저온실 안쪽 비상 개방 손잡이가 헛돈다. 손잡이와 걸쇠를 잇는 핀이 빠져 있다.',
  },
  bell: {
    name: '멀쩡한 비상벨',
    kind: '물증',
    text: '내가 눌렀을 때 벨은 크게 울렸다. 버튼에는 교수의 피가 묻어 있다. 그런데 교수가 갇혀 있는 동안 벨 소리를 들은 사람은 없다.',
  },
  tempLog: {
    name: '온도 기록',
    kind: '물증',
    text: '저온실 문 옆 기록계. 23:27 문 열림, 직후부터 온도가 설정값 아래로 하강. 23:51 문 열림. 01:40부터 문이 열린 채.',
  },
  repair: {
    name: '수리 확인서',
    kind: '물증',
    text: '3주 전 날짜. 「412호 저온실 비상 개방 장치 교체. 작동 확인 완료. 작업자 시설팀 조병욱.」 손잡이는 고장이 아니었다.',
  },
  invoice: {
    name: '드라이아이스 납품서',
    kind: '물증',
    text: '412호가 주문한 것은 20kg 한 박스. 실험실 보관함에 있어야 할 그 박스도 사라졌다.',
  },
  keys: {
    name: '실험실 뒷문',
    kind: '물증',
    text: '카드 리더가 없고 복도 카메라에 잡히지 않는다. 열쇠는 장현국, 오미경, 그리고 경비실의 비상용. 3주 전 시설팀 기사가 하루 빌렸다가 그날 반납했다.',
  },
  zoom: {
    name: '화상 회의 녹화',
    kind: '물증',
    text: '23:00부터 23:40까지 교수는 교수실에서 화상 회의를 했다. 그때까지 살아 있었고 방을 떠나지 않았다.',
  },
  drawer: {
    name: '비어 있는 서랍',
    kind: '물증',
    text: '자물쇠를 딴 흔적. 먼지 위에 공책 한 권 크기의 자국. 떨어진 견출지 「LSA-07」과 흰 결정 가루.',
  },
  ethics: {
    name: '익명 제보 출력물',
    kind: '물증',
    text: '윤리위에 들어온 익명 제보. 여백에 교수의 글씨로 「문체 — 이다인?」 「인건비 전액 회수. 지도 중단.」',
  },
  flower: {
    name: '빈 책상의 국화',
    kind: '물증',
    text: '창가의 비워진 책상에 놓인 흰 국화 한 송이. 놓인 지 하루가 안 됐다. 모서리에 작게 「L.S.A.」',
  },
  paper: {
    name: '연구실 대표 논문',
    kind: '물증',
    text: '제1저자 권세린, 교신저자(논문 책임자) 장현국, 세 번째 저자 이수아†. 취임식 초청장의 약력 맨 윗줄에 적힌 논문이다.',
  },
  nmr: {
    name: '지하 측정실 기록',
    kind: '물증',
    text: '민태오, 23:22 로그인, 시료 14건 연속 측정, 01:31 로그아웃. 시료는 손으로 갈아 끼워야 한다.',
  },
  glovebox: {
    name: '글러브박스 기록',
    kind: '물증',
    text: '권세린, 23:10 반입 / 23:38 반입 / 00:05 반출 / 00:40 반출. 시료를 꺼내 놓으면 끝낼 때까지 자리를 비울 수 없는 작업이라고 한다. 414호 문은 복도 카메라가 비춘다.',
  },
  cctv: {
    name: 'CCTV와 출입 기록',
    kind: '물증',
    text: '4층 복도: 권세린 23:10에 414호로 들어가 01:40까지 나오지 않음. 오미경 23:04 입실, 23:19 퇴실. 그 뒤 01:35까지 복도를 지난 것은 00:12의 순찰 경비원뿐. 현관: 오미경 23:21 나감, 주차장 23:24 출차. 이다인 23:58 돌아와 곧장 5층으로.',
  },
  patrol: {
    name: '순찰 기록',
    kind: '물증',
    text: '자정 순찰. 1층 00:00 / 2층 00:04 / 3층 00:08 / 4층 00:12 / 5층 00:21. 02시 순찰은 비어 있다.',
  },
  storeReceipt: {
    name: '편의점 영수증',
    kind: '물증',
    text: '이다인. 23:34 서해대 정문점, 컵라면과 삼각김밥.',
  },
  parcel: {
    name: '택배 수령 대장',
    kind: '물증',
    text: '19:40 드라이아이스 3박스 수령. 412호 1 / 3층 생물학과 2(부재, 익일 전달). 그런데 경비실에 상자가 없다.',
  },
  panel: {
    name: '방재 패널 이력',
    kind: '물증',
    text: '23:16 412호 저온실 경보 회로 차단(수동). 01:44 복구(수동). 지난 한 달 동안 이 회로가 꺼진 밤은 어제뿐. 패널은 경비실 안에 있고, 조작 열쇠는 당직 근무자가 갖고 다닌다.',
  },
  dutyLog: {
    name: '전임자의 근무일지',
    kind: '물증',
    text: '2년 전 11월 17일 밤, 전임 경비원의 기록. 「23:38 412호 저온실 비상벨. 23:40 벨 꺼짐(현장 정지 단추). 23:41 장현국 교수 내선: 오작동, 이상 없음. 23:55 장 교수 퇴근.」 다음 줄은 이튿날 아침 08:10, 학생 발견.',
  },
  photo: {
    name: '뒤집힌 사진',
    kind: '물증',
    text: '경비실 책상 유리 밑. 석사모를 쓴 젊은 여자와 이만석. 뒷면에 「수아 석사 졸업. 아빠랑.」',
  },
  argument: {
    name: '교수실의 언쟁',
    kind: '증언',
    text: '이다인의 증언. 22:40경 교수실에서 권세린이 「저는 더는 못 합니다」라고 했다. 「추천서」라는 말이 들렸다.',
  },
  trap: {
    name: '질산은 덫',
    kind: '증언',
    text: '권세린의 증언. 교수는 밤마다 서랍을 건드리는 사람을 잡으려고 서랍 속 노트 표지에 질산은을 발라 두었다.',
  },
  agno3: {
    name: '질산은의 성질',
    kind: '증언',
    text: '이다인의 설명. 묻어도 처음엔 보이지 않는다. 빛을 받으면 두세 시간 뒤부터 누렇게 비치고, 대여섯 시간이면 검게 변한다. 2주는 지워지지 않는다.',
  },
  hands: {
    name: '네 사람의 깨끗한 손',
    kind: '물증',
    text: '연구실 네 사람의 손에는 얼룩이 없다. 민태오의 갈색 얼룩은 요오드였다. 질산은이 묻은 손은 이 넷 가운데 없다.',
  },
  sua: {
    name: '이수아',
    kind: '증언',
    text: '2년 전 11월 17일, 같은 저온실에 갇혀 숨진 박사과정생. 「냉동굴」은 그녀가 지은, 연구실 사람들만 쓰는 이름이다.',
  },
  picket: {
    name: '정문 앞의 아버지',
    kind: '증언',
    text: '민태오의 증언. 2년 전 겨울, 이수아의 아버지가 정문 앞에서 석 달간 피켓을 들었다. 민태오는 고개를 숙이고 지나다녀 그 얼굴을 보지 못했다.',
  },
  cart: {
    name: '로비의 손수레',
    kind: '증언',
    text: '오미경의 증언. 23:10경 실험실 보관함에는 박스가 그대로 있었다. 23:20경 로비에서 경비원이 스티로폼 박스 두 개를 손수레에 싣고 있었다.',
  },
  guardWords: {
    name: '경비원의 진술',
    kind: '증언',
    text: '이만석의 말. 「올라가 보니 냉동굴 문이 열려 있고 교수님이 누워 계셨다.」 자정 순찰 때 4층은 조용했고 412호에는 들어가지 않았다. 드라이아이스는 저녁에 한 박스를 올려 준 것이 전부다.',
  },
};

export const INTRO = [
  n('11월 18일, 새벽 두 시 이십 분. 서해대학교 자연과학관.'),
  n("나는 서지안. 서해경찰서 강력2팀, 임용 3년 차 경위다. 팀에서는 아직도 나를 '막내'라고 부른다."),
  say('boss', '서 경위. 화학과 교수가 실험실 저온 창고에 갇혀 죽었대. 2년 전에도 같은 데서 학생 하나가 그렇게 갔어. 손잡이 고장 난 방이야. 사고야.'),
  say('boss', '가서 확인만 해. 아침 여섯 시까지 사고사로 올리고 퇴근하자고.'),
  n('확인만 하라는 말을, 나는 아직 잘 못 알아듣는다.'),
  n('현관에서 야간 경비원이 방문자 명부를 내밀었다. 볼펜을 건네는 손은 마디가 굵었고, 손톱 끝까지 깨끗했다.'),
  say('guard', '4층 412호입니다. 학생이 발견해서 제가 119를 불렀습니다. …밤늦게 고생이 많으십니다, 형사님.'),
  n('장현국, 55세. 촉매 분야의 스타 교수. 오늘 오전 열한 시에 석좌교수 취임식이 잡혀 있었다.'),
  n('장 교수는 연구실 안쪽 저온실 바닥에서 발견됐다. 영상 4도의 방. 안쪽 선반 밑에는 드라이아이스 상자들이 입을 벌리고 있었다.'),
  n('검안의의 첫 소견은 이산화탄소 중독. 드라이아이스가 내뿜은 가스가 닫힌 방을 채웠고, 문은 안에서 열리지 않았다.'),
  n('감식반은 지문을 떠 갔다. 대조 결과는 오전에나 나온다. 여섯 시까지 내가 가진 것은 눈과 귀뿐이다.'),
  n('어젯밤 이 연구실을 드나든 사람들이 4층에서 나를 기다리고 있다.'),
  n('모두가 사고라고 말한다. 2년 전과 똑같은 사고라고.'),
  n('똑같은 사고가 같은 방에서 두 번 일어났다면, 적어도 하나는 사고가 아니다.'),
  say('sys', '연구실을 조사하고, 사람들을 심문하고, 단서를 모으세요. 준비가 되면 [추리하기]로 진실을 밝힙니다. 기한은 아침 여섯 시.'),
];

// The periodic-table talk plants a clue for later chapters, so it must not be missable:
// it plays at the wall itself, or else when the four are lined up in front of it.
const TABLE_TALK = [
  say('dain', '신입생이 들어오면 원소 기호로 자기 이름 쓰기를 시켜요. 연구실 전통이에요. 저는 못 썼어요. Da라는 원소가 없거든요.'),
  say('dain', '형사님도 안 되겠네요. 주기율표에는 J가 하나도 없거든요. 되는 이름이 은근히 드물어요.'),
  n('이름을 원소로 쓴다. 쓸데없는 놀이라고 생각했다. 그때는.'),
];

const HAND_CHECK = [
  me('손을 보여 주세요. 손바닥까지 전부.'),
  n('권세린. 깨끗하다. 이다인. 깨끗하다.'),
  n('오미경은 한참 망설이다 얇은 실험 장갑을 벗었다. 잦은 세척으로 튼 손. 얼룩은 없다.'),
  n('민태오의 오른손 엄지와 검지에, 누런 갈색 얼룩이 묻어 있었다.'),
  say('taeo', '아, 아니에요! 이건 그게 아니라…'),
  say('dain', '형사님, 그건 요오드예요. 시료에 색을 입힐 때 묻는 거요. 질산은도 막 올라올 땐 저런 색이긴 한데, 그건 뭘로 문질러도 안 지워져요. 요오드는 이 약으로 바로 지워지고요.'),
  n('이다인이 건넨 약병에는 「티오황산나트륨」이라고 적혀 있다. 솜에 묻혀 민태오의 손가락을 문질렀다. 갈색 얼룩이 거짓말처럼 사라졌다.'),
  n('네 사람의 손은 모두 깨끗하다.'),
  n('장갑을 끼고 만졌다면 이 덫은 헛일이다. 손만으로는 모자란다. 어젯밤 저마다 어디 있었는지, 기록이 같은 말을 해 주는지 맞춰 봐야 한다.'),
  n('그래도 서랍은 비어 있다. 노트를 꺼낸 것이 이 넷이 아닌 누군가라면.'),
];

export const LOCATIONS = [
  {
    id: 'office',
    name: '학생실',
    desc: '412호의 입구. 책상 다섯 개가 벽을 보고 늘어서 있다. 유리문 너머가 실험실이다. 창가의 책상 하나만 유독 비어 있다.',
    hotspots: [
      {
        id: 'desk',
        label: '창가의 빈 책상을 본다',
        variants: [
          {
            lines: [
              n('먼지 하나 없이 비워진 책상. 컴퓨터도, 책도 없다.'),
              n('한가운데에 흰 국화 한 송이가 놓여 있다. 꽃잎 끝이 아직 싱싱하다. 놓인 지 하루가 안 된 꽃이다.'),
              n('책상 모서리에 누군가 유성펜으로 작게 적어 놓았다. 「L.S.A.」'),
            ],
            gives: ['flower'],
          },
        ],
      },
      {
        id: 'board',
        label: '게시판을 본다',
        variants: [
          {
            lines: [
              n('취임식 초청장이 압정에 꽂혀 있다. 「장현국 교수 석좌교수 취임식. 11월 18일 오전 11시.」 오늘이다.'),
              n('그 옆에 액자에 넣은 논문 표지. 초청장의 약력 맨 윗줄에 적힌 바로 그 논문이다.'),
              n('제1저자 권세린, 교신저자(논문 책임자) 장현국. 세 번째 저자의 이름 옆에는 작은 십자 표시가 붙어 있다. 이수아†.'),
            ],
            gives: ['paper'],
          },
        ],
      },
      {
        id: 'table',
        label: '벽의 주기율표를 본다',
        variants: [
          {
            when: { clue: 'hands' },
            lines: [
              n('벽의 주기율표. 이다인의 말대로 J는 어느 칸에도 없다. 포스트잇의 이름들을 하나씩 읽다가 그만뒀다.'),
            ],
          },
          {
            lines: [
              n('벽에 커다란 주기율표가 붙어 있다. 칸마다 이름을 적은 포스트잇이 덕지덕지 붙었다.'),
              ...TABLE_TALK,
            ],
            flag: 'table',
          },
        ],
      },
      {
        id: 'hands',
        label: '네 사람의 손을 확인한다',
        showWhen: [{ clue: 'trap' }, { clue: 'drawer' }, { clue: 'agno3' }],
        variants: [
          {
            when: { flag: 'table' },
            lines: [
              n('네 사람을 학생실 형광등 아래에 세웠다. J가 없다던 그 주기율표 앞이다.'),
              ...HAND_CHECK,
            ],
            gives: ['hands'],
          },
          {
            lines: [
              n('네 사람을 학생실로 불렀다. 권세린과 오미경이 건너오는 동안 벽의 커다란 주기율표가 눈에 들어왔다. 칸마다 이름을 적은 포스트잇이 붙어 있다.'),
              ...TABLE_TALK,
              n('네 사람이 형광등 아래에 섰다.'),
              ...HAND_CHECK,
            ],
            gives: ['hands'],
          },
        ],
      },
    ],
  },
  {
    id: 'lab',
    name: '실험실',
    desc: '냄새를 빨아내는 배기 후드 네 대가 낮게 웅웅거린다. 시약장, 실험대, 유리 기구 건조대. 안쪽 구석에 은색 단열문이 하나 있다. 저온실이다. 그 맞은편으로 복도와 통하는 뒷문이 보인다.',
    hotspots: [
      {
        id: 'chest',
        label: '드라이아이스 보관함을 본다',
        variants: [
          {
            lines: [
              n('실험대 밑의 파란 보관함. 뚜껑에 「드라이아이스 전용. 저온실 반입 금지」 스티커가 붙어 있다.'),
              n('속은 비어 있다. 바닥에 성에 자국만 네모나게 남았다. 얼마 전까지 여기 상자 하나가 들어 있었다.'),
              n('뚜껑 안쪽에 납품서가 붙어 있다. 어제 날짜다. 「412호 드라이아이스 알갱이 20kg × 1박스」. 이 연구실이 주문한 것은 한 박스다.'),
            ],
            gives: ['invoice'],
          },
        ],
      },
      {
        id: 'backdoor',
        label: '뒷문을 본다',
        variants: [
          {
            lines: [
              n('시약을 들여오는 철문. 카드 리더가 없다. 구식 열쇠 구멍 하나뿐이다.'),
              n('문을 열면 복도 끝 화물 엘리베이터 앞이다. 천장을 봤다. 카메라는 연구실 정문 쪽만 보고 있다.'),
              n('문 옆에 열쇠 관리 대장이 걸려 있다. 「뒷문 열쇠: 장현국 / 오미경 / 경비실(비상용)」'),
              n('그 밑에 대여 기록이 한 줄 있다. 「10월 27일 시설팀 조병욱. 저온실 수리. 당일 반납.」'),
              n('이 문으로 드나들면 출입 기록에도, 카메라에도 남지 않는다. 열쇠만 있다면.'),
            ],
            gives: ['keys'],
          },
        ],
      },
      {
        id: 'bench',
        label: '실험대를 둘러본다',
        variants: [
          {
            lines: [
              n('플라스크, 혼자 빙빙 도는 젓개, 번호를 매긴 유리병들. 이름을 아는 물건이 거의 없다.'),
              n('하지만 물건을 다루는 방식은 읽을 수 있다. 시약병마다 주인 이름과 날짜가 적혀 있고, 시약장은 칸마다 자물쇠가 달려 있다. 여기는 누구도 서로를 믿지 않는 방이다.'),
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'cold',
    name: '저온실',
    desc: "영상 4도. 연구실 사람들은 이 방을 '냉동굴'이라고 부른다. 두 평 남짓한 창고에 선반이 빼곡하고, 은색 문에는 손바닥만 한 창이 나 있다. 지금은 소화기로 문을 괴어 놓았다.",
    hotspots: [
      {
        id: 'scene',
        label: '쓰러져 있던 자리를 본다',
        variants: [
          {
            lines: [
              n('장 교수는 문 바로 안쪽에 쓰러져 있었다. 선반 쪽이 아니라 문 쪽으로.'),
              n('문 안쪽 스테인리스 판에 긁힌 자국이 여러 줄 나 있다. 교수의 손톱은 세 개가 깨져 있었다.'),
              n('손끝 말고는 외상이 없다. 검안의는 사망 시각을 0시 반에서 1시 사이로 봤다.'),
              n('장 교수는 들어오자마자 쓰러진 것이 아니다. 한참을, 살아서, 이 문을 두드렸다.'),
            ],
            gives: ['corpse'],
          },
        ],
      },
      {
        id: 'boxes',
        label: '스티로폼 상자를 본다',
        variants: [
          {
            lines: [
              n('맨 안쪽 선반 밑에 스티로폼 상자 셋이 밀어 넣어져 있다. 문에서는 보이지 않는 자리다. 뚜껑은 전부 벗겨져 상자 뒤에 포개져 있다. 안에는 절반쯤 줄어든 드라이아이스 알갱이.'),
              n('문 바깥쪽에는 붉은 경고문이 붙어 있다. 「드라이아이스·액체질소 반입 금지. 질식 위험.」 2년 전 사고 뒤에 붙인 것이라고 했다.'),
              n('금지된 물건이, 세 상자나, 뚜껑까지 열린 채로 여기 들어와 있다.'),
              n('쪼그려 앉자 숨이 가빠졌다. 이산화탄소는 공기보다 무겁다. 가스는 아직 바닥에 고여 있다. 나는 얼른 일어섰다.'),
            ],
            gives: ['dryice'],
          },
        ],
      },
      {
        id: 'logger',
        label: '문 옆의 온도 기록계를 본다',
        variants: [
          {
            lines: [
              n('문 바깥벽에 손바닥만 한 온도 기록계가 달려 있다. 1분마다 방 안 온도를 적고, 문이 열리면 그 시각을 따로 찍는다.'),
              n('어젯밤 기록을 넘겼다. 23시 27분, 문 열림. 그 직후부터 온도가 설정값 아래로 꾸준히 떨어진다.'),
              n('23시 51분, 문 열림. 그리고 01시 40분부터는 문이 열린 채다.'),
              n('자정 전에 문은 두 번 열렸다. 방이 차가워지기 시작한 것은 첫 번째부터다.'),
            ],
            gives: ['tempLog'],
          },
        ],
      },
      {
        id: 'handle',
        label: '안쪽 손잡이를 살핀다',
        variants: [
          {
            lines: [
              n('문 안쪽에는 초록색 비상 개방 손잡이가 달려 있다. 밖에서 잠겨도 이것을 밀면 열리게 되어 있다.'),
              n('안에서 직접 봐야 했다. 나는 문턱을 넘어 손잡이 쪽으로 몸을 숙였다.'),
              n('발끝에 뭔가 걸렸다. 문을 괴어 둔 소화기가 젖은 바닥에서 미끄러졌다.'),
              n('등 뒤에서 문이 닫혔다. 철컥.'),
              n('손잡이를 밀었다. 헛돈다. 다시. 헛돈다. 손잡이와 걸쇠를 잇는 핀이 있어야 할 자리에 구멍만 뚫려 있다.'),
              n('숨을 얕게 쉬었다. 벽의 붉은 버튼. 깨진 커버 밑, 버튼 위에 마른 피가 묻어 있다. 교수도 이것을 눌렀다.'),
              n('나는 주먹으로 버튼을 내리쳤다. 벨이 울렸다. 건물이 떠나가라.'),
              n('일 분쯤 지났을까. 문이 벌컥 열렸다. 흰 면장갑을 낀 손이 내 팔을 붙들어 밖으로 끌어냈다.'),
              say('guard', '형사님! 괜찮으십니까! …여긴, 여긴 혼자 들어가시면 안 됩니다. 절대로.'),
              n('경비원이었다. 1층에서 벨 소리를 듣고 뛰어 올라왔다고 했다. 그가 문 옆 벽의 정지 단추를 누르자 벨이 멎었다. 장갑 낀 손이 나보다 더 떨리고 있었다.'),
              n('문 앞에는 오미경이 먼저 와 있었다. 손잡이에 손을 뻗다 만 채로 굳어 있었다.'),
              say('mikyung', '…미안해요. 벨이 울리는데, 손이, 손이 안 움직였어요. 2년 전에도 이 문 앞이었어요.'),
              n('숨을 고르며 생각했다. 벨은 멀쩡하다. 이렇게 크게 울린다.'),
              n('그런데 어젯밤 장 교수가 버튼에 피가 묻도록 눌렀을 때는, 이 소리를 들었다는 사람이 없다.'),
            ],
            gives: ['pin', 'bell'],
            flag: 'rescued',
          },
        ],
      },
    ],
  },
  {
    id: 'prof',
    name: '교수실',
    desc: '연구실 안쪽의 독방. 벽 한 면이 상패와 감사패다. 책상 위에는 노트북과 충전 중인 휴대폰. 주인은 금방 돌아올 생각으로 이 방을 나갔다.',
    hotspots: [
      {
        id: 'laptop',
        label: '노트북을 본다',
        variants: [
          {
            lines: [
              n('화면에 화상 회의 프로그램이 떠 있다. 녹화 파일이 남았다. 어젯밤 23시 00분부터 23시 40분까지, 독일 공동연구자와의 회의.'),
              n('녹화를 돌려 봤다. 장 교수는 40분 내내 화면 앞에 앉아 있다. 23시 40분, 그는 웃으며 말한다. 「내일 취임식 끝나고 다시 얘기하죠. 저는 오늘 시료만 저온실에 넣어 두고 퇴근합니다. 매일 밤 제 손으로 넣거든요.」'),
              n('23시 40분까지 그는 살아 있었고, 이 방을 떠나지 않았다.'),
            ],
            gives: ['zoom'],
          },
        ],
      },
      {
        id: 'drawer',
        label: '책상 서랍을 본다',
        variants: [
          {
            lines: [
              n('맨 아래 서랍에만 자물쇠가 달려 있다. 열쇠 구멍 둘레에 가는 긁힌 자국. 열쇠가 아닌 것으로 연 흔적이다.'),
              n('서랍은 비어 있다. 바닥의 먼지 위에 공책 한 권 크기의 네모난 자국만 남았다. 오랫동안 그 자리에 있던 물건이다.'),
              n('안쪽 구석에 견출지 한 장이 떨어져 있다. 「LSA-07」. 그리고 바닥에 흩어진 희고 고운 결정 가루 몇 알.'),
            ],
            gives: ['drawer'],
          },
        ],
      },
      {
        id: 'printout',
        label: '책상 위 서류를 본다',
        variants: [
          {
            lines: [
              n('인쇄한 이메일 한 장. 지난주 연구윤리위원회에 들어온 익명 제보다. 「장현국 교수 연구실의 인건비 회수와 폭언, 그리고 2년 전 논문의 데이터에 대하여.」'),
              n('여백에 교수의 글씨. 「문체 — 이다인?」 「다음 학기 인건비 전액 회수. 지도 중단.」'),
              n('제보자가 누구인지, 장 교수는 이미 짐작하고 있었다.'),
            ],
            gives: ['ethics'],
          },
        ],
      },
      {
        id: 'phone',
        label: '휴대폰을 본다',
        variants: [
          {
            lines: [
              n('책상 위 휴대폰은 충전기에 꽂혀 있다. 부재중 전화는 없다.'),
              n('장 교수는 휴대폰을 두고 저온실에 갔다. 어차피 그 방에서는 전파가 잡히지 않는다고 했다.'),
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'inst',
    name: '기기실',
    desc: '복도 맞은편 414호. 커다란 수조 같은 유리 상자에 검은 고무장갑 두 짝이 안쪽으로 매달려 있다. 공기와 닿으면 안 되는 물질을 다루는 글러브박스라고 했다.',
    hotspots: [
      {
        id: 'gbox',
        label: '글러브박스 기록을 본다',
        variants: [
          {
            lines: [
              n('장비 옆 태블릿에 사용 기록이 남는다. 물건을 넣고 뺄 때마다 진공 펌프가 돌고, 그 시각이 찍힌다.'),
              n('「권세린 23:10 반입 / 23:38 반입 / 00:05 반출 / 00:40 반출」'),
              n('시료를 꺼내 놓으면 끝낼 때까지 자리를 비울 수 없는 작업이라고 했다.'),
              n('기록 사이는 30분 안팎씩 비어 있다. 문밖 복도 천장에는 카메라가 달려 있다. 이 414호 문을 내려다보는 자리다.'),
            ],
            gives: ['glovebox'],
          },
        ],
      },
      {
        id: 'booking',
        label: '공동기기 예약 시스템을 본다',
        variants: [
          {
            lines: [
              n('벽의 PC에 학과 공동기기 예약 화면이 떠 있다. 지하 1층 측정실의 어젯밤 기록.'),
              n('「민태오 23:22 로그인 / 시료 14건 연속 측정 / 01:31 로그아웃」'),
              n('시료를 한 건씩 손으로 갈아 끼워야 하는 장비다. 측정 파일 14개의 저장 시각이 9분 남짓한 간격으로 고르게 찍혀 있다.'),
              n('첫 파일은 23시 26분, 마지막 파일은 01시 29분에 저장됐다.'),
            ],
            gives: ['nmr'],
          },
        ],
      },
    ],
  },
  {
    id: 'guardroom',
    name: '1층 경비실',
    desc: '현관 옆 두 평짜리 방. 벽에는 CCTV 모니터 여덟 개와 붉은 글자가 흐르는 방재 패널. 책꽂이에는 해마다 한 권씩 근무일지가 꽂혀 있다. 책상 위 보온병에서 유자 냄새가 난다.',
    hotspots: [
      {
        id: 'cctv',
        label: 'CCTV와 출입 기록을 본다',
        variants: [
          {
            lines: [
              n('경비원이 어젯밤 4층 복도 영상을 돌려 주고, 412호 정문의 카드 기록도 뽑아 줬다. 복도 카메라는 412호 정문과 맞은편 414호 문을 비춘다.'),
              n('22시 31분, 오미경 퇴실. 그런데 23시 4분에 오미경의 카드가 다시 찍힌다. 23시 19분에 나간다.'),
              n('그사이 23시 10분, 권세린이 414호로 들어간다. 23시 14분, 이다인이 지갑을 들고 나간다. 23시 15분, 민태오가 계단으로 내려간다.'),
              n('23시 19분 뒤로 4층 복도는 비어 있다. 0시 12분에 손전등을 든 순찰 경비원이 지나갈 뿐이다. 01시 35분에 민태오가 올라오고, 01시 40분에 복도로 뛰쳐나온다. 그제야 414호 문이 다시 열린다.'),
              n('현관 출입문 카메라도 돌려 봤다. 23시 21분, 오미경이 건물을 나간다. 주차 관리 화면에는 23시 24분에 오미경의 차가 나간 기록이 있다.'),
              n('23시 58분, 이다인이 편의점 봉지를 들고 현관으로 돌아와 계단으로 곧장 5층에 올라간다. 4층 복도에는 나타나지 않는다.'),
            ],
            gives: ['cctv'],
          },
        ],
      },
      {
        id: 'patrol',
        label: '순찰 기록을 본다',
        variants: [
          {
            lines: [
              n('순찰자는 층마다 벽의 태그에 단말기를 찍는다. 어젯밤 자정 순찰.'),
              n('「1층 00:00 / 2층 00:04 / 3층 00:08 / 4층 00:12 / 5층 00:21」'),
              n('22시 순찰도 층마다 4분 간격으로 찍혀 있다. 02시 칸만 비어 있다. 그 시각 경비원은 현관에서 구급대와 경찰을 맞고 있었다.'),
            ],
            gives: ['patrol'],
          },
        ],
      },
      {
        id: 'tea',
        label: '유자차를 받는다',
        variants: [
          {
            when: [{ flag: 'rescued' }, { clue: 'sua' }],
            lines: [
              n('경비원이 보온병 뚜껑에 유자차를 따라 내밀었다. 흰 면장갑을 낀 손이다.'),
              say('guard', '새벽엔 손이 시려서요. 늙으니 별수 없습니다. 드세요, 속이 좀 풀릴 겁니다.'),
              say('guard', '우리 딸도 형사님 또래였는데요. 걔도 꼭 이렇게 밤을 새우고 다녔지요.'),
              n('유자차는 달고 뜨거웠다. 벽에는 누렇게 바랜 자격증이 걸려 있다. 「소방설비기사. 이만석.」'),
            ],
          },
          {
            when: { clue: 'sua' },
            lines: [
              n('경비원이 보온병 뚜껑에 유자차를 따라 내밀었다. 마디가 굵은 맨손이다.'),
              say('guard', '드세요, 속이 좀 풀릴 겁니다. 밤샘에는 단 게 최곱니다.'),
              say('guard', '우리 딸도 형사님 또래였는데요. 걔도 꼭 이렇게 밤을 새우고 다녔지요.'),
              n('유자차는 달고 뜨거웠다. 벽에는 누렇게 바랜 자격증이 걸려 있다. 「소방설비기사. 이만석.」'),
            ],
          },
          {
            when: { flag: 'rescued' },
            lines: [
              n('경비원이 보온병 뚜껑에 유자차를 따라 내밀었다. 흰 면장갑을 낀 손이다.'),
              say('guard', '새벽엔 손이 시려서요. 늙으니 별수 없습니다. 드세요, 속이 좀 풀릴 겁니다.'),
              n('유자차는 달고 뜨거웠다. 벽에는 누렇게 바랜 자격증이 걸려 있다. 「소방설비기사. 이만석.」'),
            ],
          },
          {
            lines: [
              n('경비원이 보온병 뚜껑에 유자차를 따라 내밀었다. 마디가 굵은 맨손이다.'),
              say('guard', '드세요, 속이 좀 풀릴 겁니다. 밤샘에는 단 게 최곱니다.'),
              n('유자차는 달고 뜨거웠다. 벽에는 누렇게 바랜 자격증이 걸려 있다. 「소방설비기사. 이만석.」'),
            ],
          },
        ],
      },
      {
        id: 'parcel',
        label: '택배 수령 대장을 본다',
        showWhen: [{ clue: 'hands' }, { clue: 'repair' }],
        variants: [
          {
            lines: [
              n('이 넷이 아닌 누군가. 먼저 떠오른 것은 3주 전에 그 손잡이를 갈아 끼운 시설팀 기사였다.'),
              n('경비실 벽에 시설팀의 이번 달 근무표가 붙어 있다. 조병욱의 칸에는 「11월 13일~24일 대전 교육 파견」이라고 찍혀 있다. 대전의 연수원에 전화를 걸었다. 합숙 교육이고, 어젯밤 11시 점호 명단에 그의 서명이 있다고 했다.'),
              n('나는 처음부터 다시 보기로 했다. 어젯밤 이 건물로 들어온 모든 것을.'),
              n('경비실 책상의 택배 수령 대장. 어제 날짜. 「19:40 드라이아이스 3박스 수령. 412호 1 / 3층 생물학과 2(부재, 익일 전달).」'),
              n('3층 몫 두 박스는 아침까지 이 방에 있어야 한다.'),
              n('경비실을 둘러봤다. 택배 선반은 비어 있다. 스티로폼 상자는 어디에도 없다.'),
            ],
            gives: ['parcel'],
          },
        ],
      },
      {
        id: 'panel',
        label: '방재 패널의 이력을 본다',
        showWhen: [{ clue: 'hands' }, { clue: 'bell' }],
        variants: [
          {
            lines: [
              n('저온실 벨은 내가 눌렀을 때 멀쩡히 울렸다. 장 교수가 눌렀을 때는 왜 울리지 않았나.'),
              n('붉은 글자가 흐르는 방재 패널. 건물의 화재 감지기와 비상벨이 전부 이 상자로 모인다. 이력 버튼을 눌러 어젯밤으로 거슬러 올라갔다.'),
              n('「23:16 412호 저온실 경보 회로 — 차단(수동)」 「01:44 412호 저온실 경보 회로 — 복구(수동)」'),
              n('그 2시간 28분 동안 저온실의 비상벨은 울릴 수 없었다.'),
              n('이력을 한 달 치 넘겨 봤다. 이 회로가 꺼진 밤은 어제 하루뿐이다.'),
              n('패널 덮개에는 열쇠 구멍이 있고, 그 옆에 안내문이 붙어 있다. 「조작 열쇠는 당직 근무자 휴대.」'),
            ],
            gives: ['panel'],
          },
        ],
      },
      {
        id: 'logbook',
        label: '책꽂이의 근무일지를 본다',
        showWhen: [{ clue: 'panel' }, { clue: 'sua' }],
        variants: [
          {
            lines: [
              n('패널의 이력은 석 달이면 지워진다. 2년 전 그 밤의 일은 종이에만 남아 있다. 책꽂이에서 그해의 근무일지를 뽑았다.'),
              n('11월 17일 쪽은 귀퉁이가 닳아 저절로 펼쳐졌다. 표지에 적힌 근무자 이름은 이만석이 아니다. 전임자의 일지다.'),
              n('「23:38 412호 저온실 비상벨.」 「23:40 벨 꺼짐(현장 정지 단추).」 「23:41 412호에서 내선. 장현국 교수: 오작동입니다. 이상 없습니다.」 「23:55 장 교수 퇴근.」'),
              n('다음 줄은 이튿날 아침이다. 「08:10 412호 오미경 신고. 저온실에서 학생 발견. 119.」'),
              n('2년 전 그 사건을 맡은 사람은 박 반장이다. 박 반장이 이 쪽을 펼쳐 봤는지, 나는 모른다.'),
            ],
            gives: ['dutyLog'],
          },
        ],
      },
      {
        id: 'glass',
        label: '책상 유리 밑을 본다',
        showWhen: [{ clue: 'parcel' }, { clue: 'panel' }, { clue: 'sua' }],
        variants: [
          {
            lines: [
              n('경비원이 순찰을 나간 사이, 책상 유리 밑에 끼워 둔 것들을 봤다. 순찰 시간표, 중국집 전단. 그리고 뒤집어 끼운 사진 한 장. 흰 뒷면에 볼펜 글씨가 있다. 「수아 석사 졸업. 아빠랑.」'),
              n('유리를 들어 사진을 뒤집었다. 석사모를 쓴 젊은 여자가 꽃다발을 안고 웃고 있다. 그 옆에, 지금보다 덜 늙은 이만석이 어색하게 서 있다.'),
              n('나는 사진을 원래대로 뒤집어 끼웠다.'),
            ],
            gives: ['photo'],
          },
        ],
      },
    ],
  },
];

export const VICTIM = {
  id: 'victim',
  name: '장현국',
  age: 55,
  role: '화학과 교수',
  tag: '피해자',
  desc: '촉매 분야의 스타 교수. 오늘 오전 석좌교수 취임식을 앞두고 연구실 저온실에서 숨진 채 발견됐다.',
};

export const PEOPLE = [
  {
    id: 'dain',
    name: '이다인',
    age: 25,
    role: '석사 1년 차',
    tag: '참고인',
    loc: 'office',
    desc: '연구실 막내. 묻는 말마다 화학을 풀어서 설명해 준다. 밤 11시 15분쯤 편의점에 갔다가 5층 휴게실에서 잠들었다고 했다.',
    topics: [
      {
        id: 'alibi',
        label: '어젯밤 행적',
        lines: [
          say('dain', '11시 15분쯤 배가 고파서 편의점에 갔어요. 컵라면 사서 5층 휴게실에서 먹고… 깜빡 잠들었어요. 태오 선배 비명 소리에 깼고요.'),
          say('dain', '영수증이요? 여기요. 이런 건 잘 안 버려서요.'),
          n('「23:34 서해대 정문점. 컵라면 1, 삼각김밥 1.」'),
        ],
        gives: ['storeReceipt'],
      },
      {
        id: 'mood',
        label: '어제 연구실 분위기',
        lines: [
          say('dain', '…안 좋았어요. 미팅에서 교수님이 태오 선배 졸업을 또 1년 미루겠다고 하셨거든요. 선배가 처음으로 소리를 질렀어요.'),
          say('dain', '그러고 10시 40분쯤엔 교수실에서 큰 소리가 났어요. 이번엔 권 박사님 목소리였어요. 「저는 더는 못 합니다」 하고요.'),
          say('dain', '교수님이 뭐라고 하셨는지는 잘 못 들었어요. 「추천서」라는 말만 들렸어요.'),
        ],
        gives: ['argument'],
      },
      {
        id: 'sua',
        label: '창가의 빈 책상',
        when: { clue: 'flower' },
        lines: [
          me('창가 책상은 왜 비어 있죠.'),
          say('dain', '…수아 선배 자리예요. 이수아 선배. 2년 전 11월 17일에 저 저온실에서 돌아가셨대요. 어제가 꼭 2년 되는 날이었어요. 저는 입학 전이라 뵌 적은 없어요.'),
          say('dain', '밤에 혼자 실험하다 갇혔다고 들었어요. 그때는 드라이아이스를 저기 쌓아 뒀대요. 손잡이도 고장이었고요.'),
          say('dain', "'냉동굴'이라는 이름도 수아 선배가 지은 거래요. 연구실 사람들만 그렇게 불러요. 밖에서는 그냥 저온실이라고 하죠."),
          say('dain', '꽃은… 매달 17일마다 놓여 있어요. 누가 놓는지는 아무도 몰라요. 다들 자기 말고 다른 누군가겠거니 해요.'),
        ],
        gives: ['sua'],
      },
      {
        id: 'agno3',
        label: '질산은이란',
        when: { clue: 'trap' },
        lines: [
          me('서랍 속 노트에 질산은을 발라 뒀다고 합니다. 질산은이 손에 묻으면 어떻게 됩니까.'),
          say('dain', '처음엔 아무것도 안 보여요. 물처럼 투명하거든요. 그런데 빛을 받으면 피부에서 은으로 바뀌면서 색이 올라와요. 두세 시간이면 누렇게 비치고, 대여섯 시간이면 까매져요.'),
          say('dain', "비누로는 안 지워져요. 각질이 벗겨질 때까지 2주는 가요. 실험하다 묻으면 다음 날 다들 알아요. '너 어제 은 만졌구나' 하고."),
          say('dain', '어두운 데 두면 색이 안 변하니까… 서랍 속에 발라 두면 감쪽같겠네요.'),
        ],
        gives: ['agno3'],
      },
    ],
    present: {
      ethics: {
        lines: [
          me('교수 책상에 있던 겁니다. 윤리위에 들어온 익명 제보. 여백에 이다인 씨 이름이 적혀 있어요.'),
          say('dain', '…………아셨구나. 교수님이.'),
          say('dain', '네, 제가 썼어요. 매달 인건비가 들어오면 절반을 현금으로 뽑아서 드려야 해요. 못 하겠다고 하면 「너 같은 건 어디 가서도 화학 못 해」라고 하세요.'),
          say('dain', '죽었으면 좋겠다고 생각한 적 있어요. 솔직히요. 근데 형사님, 저는 그 사람이 벌받는 걸 보고 싶었어요. 죽으면 벌을 못 받잖아요.'),
        ],
      },
      paper: {
        lines: [
          say('dain', '그 논문이요? 연구실 대표 논문이에요. 교수님이 저걸로 석좌교수 되시는 거고요.'),
          say('dain', '…수아 선배 실험이었다는 얘기는, 다들 알면서 안 해요.'),
        ],
      },
      tempLog: {
        lines: [
          say('dain', '온도가 떨어졌다고요? 드라이아이스가 영하 78도니까요. 냉장고에 얼음을 한가득 넣은 셈이에요. 기계가 식힐 필요가 없어지죠.'),
          say('dain', '그 얼음은 녹지도 않아요. 고체에서 곧장 기체가 돼요. 승화라고 하죠. 다 없어지고 나면 물 자국 하나 안 남아요.'),
        ],
      },
      dryice: {
        lines: [
          say('dain', '세 박스요? 저희는 한 박스만 시켜요. 그것도 실험실 보관함에 넣지, 저기엔 절대 안 넣어요. 신입생 안전교육 첫 장에 나오는걸요.'),
        ],
      },
    },
    fallback: [say('dain', '음… 그건 제가 잘 모르겠어요. 죄송해요.')],
  },
  {
    id: 'taeo',
    name: '민태오',
    age: 33,
    role: '박사과정 7년 차',
    tag: '참고인',
    loc: 'office',
    desc: '최초 발견자. 어제 미팅에서 졸업이 또 1년 미뤄졌다. 밤새 책상에서 논문을 쓰고 있었다고 했다.',
    topics: [
      {
        id: 'alibi',
        label: '어젯밤 행적',
        lines: [
          say('taeo', '미팅 끝나고 계속 제 자리에서 논문 썼어요. 1시 40분쯤 시료를 넣으러 냉동굴에, 아니, 저온실에 갔는데… 문 창으로 교수님이 바닥에…'),
          me('밤 11시부터 1시 40분까지 계속 이 방에 있었다는 거죠.'),
          say('taeo', '…네.'),
        ],
      },
      {
        id: 'find',
        label: '발견했을 때',
        lines: [
          say('taeo', '문은 닫혀 있었어요. 밖에서는 그냥 열려요. 열자마자 숨이 턱 막혀서… 교수님을 끌어내고 경비실에 전화했어요.'),
          say('taeo', '경비 아저씨가 금방 올라오셨어요. 119 부르고, 문을 활짝 열어 놓고 환기를 시키셨죠. 침착하시더라고요.'),
        ],
      },
      {
        id: 'grad',
        label: '교수와의 관계',
        lines: [
          say('taeo', '7년이에요, 형사님. 제 1저자 논문 두 편이 다른 사람 이름으로 나갔어요. 졸업은 교수님 도장 하나에 달렸고요.'),
          say('taeo', '어제는 진짜 죽이고 싶었어요. 근데 그 사람이 죽으면 제 7년은 누가 도장 찍어 줍니까.'),
        ],
      },
      {
        id: 'picket',
        label: '2년 전의 일',
        when: { clue: 'sua' },
        lines: [
          say('taeo', '수아 일요… 저는 그날 일찍 퇴근했어요. 다음 날 와 보니 경찰이 와 있더라고요.'),
          say('taeo', '그 겨울에 정문 앞에서 피켓 들고 서 있던 아저씨가 있었어요. 수아 아버님이라고 했는데. 「내 딸은 사고로 죽지 않았다」 그런 거였나.'),
          say('taeo', '저는… 그 앞을 석 달을 고개 숙이고 지나다녔어요. 얼굴을 한 번도 못 봤어요. 봄이 되니까 안 보이시더라고요.'),
        ],
        gives: ['picket'],
      },
    ],
    present: {
      nmr: {
        lines: [
          me('지하 측정실 기록입니다. 23시 22분부터 01시 31분까지, 민태오 씨 이름으로 시료 14건. 책상에 있었다고 했죠.'),
          say('taeo', '…그걸 보셨어요.'),
          say('taeo', '회사 면접용 데이터예요. 다음 달에 연구소 면접이 있어요. 교수님이 알면 추천서는커녕 업계에 전화를 돌렸을 거예요. 그래서 밤에 몰래 쟀어요.'),
          say('taeo', '11시 15분에 내려가서 1시 35분에 올라왔어요. 올라와서 시료 넣으러 갔다가 발견한 거고요. 거짓말해서 죄송합니다.'),
        ],
      },
      paper: {
        lines: [
          say('taeo', '…세 번째 저자. 수아가 3년을 한 실험인데요. 권 박사님도 그 얘기만 나오면 자리를 떠요.'),
        ],
      },
    },
    fallback: [say('taeo', '그건… 잘 모르겠습니다.')],
  },
  {
    id: 'serin',
    name: '권세린',
    age: 36,
    role: '박사후연구원',
    tag: '참고인',
    loc: 'inst',
    desc: '교수의 오른팔로 불린다. 연구실 대표 논문의 제1저자. 밤새 기기실에서 글러브박스 작업을 했다고 했다.',
    topics: [
      {
        id: 'alibi',
        label: '어젯밤 행적',
        lines: [
          say('serin', '11시 10분부터 여기서 글러브박스 작업을 했어요. 시료를 꺼내 놓으면 끝낼 때까지 자리를 못 떠요. 공기에 닿으면 못 쓰게 되거든요. 기록 보시면 나와요.'),
          me('미팅이 끝난 뒤 교수님을 따로 만난 적은.'),
          say('serin', '없어요. 미팅이 마지막이에요.'),
        ],
      },
      {
        id: 'habit',
        label: '교수는 어떤 사람이었나',
        lines: [
          say('serin', '…뛰어난 분이에요. 연구비를 끌어오는 능력도, 논문을 내는 속도도요.'),
          say('serin', '매일 밤 퇴근 전에 그날의 핵심 시료를 직접 저온실 금고함에 넣으세요. 아무도 안 믿으시거든요. 12시 전후에요. 이 건물에서 밤을 새워 본 사람이면 다 아는 습관이에요.'),
        ],
      },
      {
        id: 'accident',
        label: '사고라고 보는가',
        lines: [
          say('serin', '사고죠. 2년 전에도 그랬으니까요. 그 방은… 원래 그런 방이에요.'),
          n("권세린은 '원래'라는 말을 하면서 내 눈을 보지 않았다."),
        ],
      },
    ],
    present: {
      argument: {
        lines: [
          me('22시 40분, 교수실에서 권세린 씨 목소리를 들은 사람이 있습니다. 「저는 더는 못 합니다.」 미팅이 마지막이라고 했죠.'),
          say('serin', '…………'),
          say('serin', "다음 달에 교수 임용 심사가 있어요. 교수님 추천서가 필요해요. 그런데 어제 그러시더군요. 취임식 끝나면 '남은 정리'를 같이 하자고."),
          say('serin', '수아의 원본 연구노트요. 그걸 파쇄하자는 거였어요. 저는 못 한다고 했어요. 그랬더니 「추천서는 없던 일로 하지. 그 논문 1저자가 누군지 잊었나」.'),
          say('serin', '그리고 이런 말도 했어요. 「요즘 밤마다 누가 내 서랍을 건드려. 쥐새끼가 누군지 내일이면 알게 될 거야. 노트 표지에 질산은을 발라 놨거든. 손끝이 까매질 테니까.」'),
          say('serin', '저를 보면서 한 말이었어요. 전 그 서랍에 손댄 적 없어요.'),
        ],
        gives: ['trap'],
      },
      paper: {
        lines: [
          say('serin', "…제 이름이 맨 앞에 있죠. 실험은 수아가 했어요. 저는 글을 다듬었을 뿐이에요. 교수님이 '네 임용에 필요하다'고 하셨고, 저는 거절하지 않았어요."),
          say('serin', '논문에 실린 수치는 수아의 노트에 적힌 값보다 높아요. 누가 고쳤는지, 저는 묻지 않았어요. 2년 동안.'),
        ],
      },
      glovebox: {
        lines: [
          say('serin', '말씀드렸잖아요. 그 시간엔 여기서 자리를 못 떴어요.'),
        ],
      },
      drawer: {
        lines: [
          say('serin', 'LSA-07… 수아의 일곱 번째 노트예요. 논문에 쓴 실험의 원본 기록이 거기 다 있어요.'),
          say('serin', '사고 뒤에 없어졌다고들 했어요. …저도 어제까지는 그런 줄 알았고요.'),
        ],
      },
    },
    fallback: [say('serin', '그건 제가 답할 수 있는 일이 아니에요.')],
  },
  {
    id: 'mikyung',
    name: '오미경',
    age: 49,
    role: '테크니션 · 안전관리 담당',
    tag: '참고인',
    loc: 'lab',
    desc: '연구실 살림과 안전을 15년째 맡아 왔다. 밤 10시 반에 퇴근했다가 연락을 받고 다시 나왔다고 했다.',
    topics: [
      {
        id: 'alibi',
        label: '어젯밤 행적',
        lines: [
          say('mikyung', '10시 반에 퇴근해서 집에 있었어요. 2시에 경찰 전화 받고 다시 나온 거예요.'),
        ],
      },
      {
        id: 'handle',
        label: '저온실 손잡이',
        lines: [
          say('mikyung', '원래 고장이라고요? 누가 그래요! 3주 전에 통째로 갈았어요.'),
          say('mikyung', "수아 그렇게 되고 임시로 고쳤는데 석 달 만에 또 헛돌았어요. 통째로 갈아야 한다는데 교수님이 '예산 없다'고 2년을 결재를 안 해 줬어요. 이번엔 학교 안전점검에 걸려서 겨우 한 거예요. 여기 작업 확인서 있어요."),
          n('「자연과학관 412호 저온실 비상 개방 장치 교체. 작동 확인 완료. 작업자 시설팀 조병욱.」 3주 전 날짜다.'),
          say('mikyung', '조 기사가 핀을 끼우는 걸 내가 옆에서 지켜봤어요. 그러고 내가 안에서 직접 열 번을 밀어 봤어요. 열 번 다 열렸어요.'),
        ],
        gives: ['repair'],
      },
      {
        id: 'rule',
        label: '드라이아이스 관리',
        lines: [
          say('mikyung', '저녁 8시쯤 경비 아저씨가 우리 몫 한 박스를 올려다 줬어요. 내가 받아서 실험실 보관함에 넣었고요.'),
          say('mikyung', '저온실엔 절대 안 넣어요. 2년 전에 그 난리를 겪고 내가 문에 경고문까지 붙였는데.'),
        ],
      },
      {
        id: 'past',
        label: '2년 전 사고',
        when: { clue: 'sua' },
        lines: [
          say('mikyung', '…내가 발견했어요. 아침에 출근해서. 문 안쪽이 온통 긁혀 있었어요.'),
          say('mikyung', '그 애가 죽기 다섯 달 전에 내가 수리 요청서를 올렸어요. 두 번. 두 번 다 교수님이 반려했어요.'),
          say('mikyung', '그 서류, 나 아직 갖고 있어요. 버릴 수가 없어서.'),
          say('mikyung', '장례식엔 교수님이 연구실 사람들을 못 가게 했어요. 그래서 나는 그 애 아버님 얼굴도 몰라요.'),
        ],
      },
    ],
    present: {
      cctv: {
        lines: [
          me('출입 기록입니다. 23시 4분 입실, 23시 19분 퇴실. 집에 있었다고 했죠.'),
          say('mikyung', '…………하.'),
          say('mikyung', '팔라듐 촉매요. 시약장에서 몇 그램 챙겼어요. 3년째 월급은 동결인데 교수님은 연구비로 골프를 쳐요. 나도 알아요, 도둑질인 거.'),
          say('mikyung', '교수님은 그때 교수실에서 영어로 통화 중이었어요. 문틈으로 소리가 났어요. 나는 시약장만 열고 바로 나왔어요.'),
          me('그때 드라이아이스 보관함은.'),
          say('mikyung', '우리 박스 그대로 있었어요. 저온실 앞엔 아무것도 없었고요. 그건 내가 장담해요. 15년을 본 방인데.'),
          say('mikyung', '아, 내려가서 1층 로비에서 경비 아저씨를 봤어요. 손수레에 스티로폼 박스 두 개를 싣고 화물 엘리베이터 앞에 서 있더라고요. 3층에 택배 올려다 주나 보다 했죠.'),
        ],
        gives: ['cart'],
      },
      pin: {
        lines: [
          say('mikyung', '핀이 빠졌다고요? 말도 안 돼요. 그건 저절로 빠지는 물건이 아니에요. 나사를 풀어야 빠져요.'),
        ],
      },
      invoice: {
        lines: [
          say('mikyung', '한 박스 맞아요. 우리는 늘 한 박스예요.'),
        ],
      },
    },
    fallback: [say('mikyung', '그건 나한테 물을 일이 아닌 것 같은데요.')],
  },
  {
    id: 'guard',
    name: '이만석',
    age: 61,
    role: '야간 경비원',
    tag: '참고인',
    loc: 'guardroom',
    desc: '자연과학관의 야간 경비원. 신고를 받고 가장 먼저 현장에 올라와 119를 불렀다. 출입 기록과 CCTV를 관리한다.',
    topics: [
      {
        id: 'night',
        label: '어젯밤 있었던 일',
        lines: [
          say('guard', '1시 40분쯤 412호에서 내선이 왔습니다. 올라가 보니 냉동굴 문이 열려 있고 교수님이 바닥에 누워 계셨어요. 바로 119를 불렀습니다.'),
          say('guard', '순찰은 10시, 12시, 2시, 4시에 돕니다. 어젯밤 2시는 못 돌았지요. 자정 순찰 때 4층은 조용했습니다. 412호 안에는 들어가지 않았고요.'),
          me('드라이아이스는 어제 직접 받으셨죠.'),
          say('guard', '예. 저녁에 412호 몫 한 박스를 오 선생님께 올려다 드렸습니다. 그게 전부입니다.'),
        ],
        gives: ['guardWords'],
      },
      {
        id: 'career',
        label: '이 건물에서 일한 지',
        lines: [
          say('guard', '1년 반 됐습니다. 그 전에는 소방 설비 일을 30년 했지요. 정년하고 용역 회사를 통해 왔습니다.'),
          say('guard', '밤에 이 건물에 불 켜진 방은 늘 정해져 있어요. 교수님들은 일찍 가시고, 학생들만 남습니다. 딱하지요.'),
        ],
      },
      {
        id: 'alarm',
        label: '저온실 경보',
        lines: [
          say('guard', '어젯밤엔 경보가 한 번도 안 울렸습니다. 울렸으면 제가 바로 올라갔지요.'),
        ],
      },
      {
        id: 'past',
        label: '2년 전 사고',
        when: { clue: 'sua' },
        lines: [
          me('2년 전 사고에 대해 들은 것이 있습니까.'),
          say('guard', '…그 학생도 꼭 이맘때였지요. 밤 열한 시 넘어서, 혼자서. 벨을 눌렀는데 아무도 안 왔다고.'),
          say('guard', '그렇게 들었습니다. 전임자한테요. 저는 그 뒤에 왔으니까요.'),
          n('이만석은 보온병을 두 손으로 감싸 쥐었다.'),
        ],
      },
    ],
    present: {
      flower: {
        lines: [
          say('guard', '국화요? 글쎄요… 순찰 돌다 보면 그 책상에 꽃이 있는 날이 있더군요. 학생들이 놓나 보다 했습니다.'),
        ],
      },
      patrol: {
        lines: [
          say('guard', '4층에서 5층이 좀 걸렸다고요? 4층은 방이 많습니다. 문단속을 하나하나 확인하다 보면 그렇지요.'),
        ],
      },
      cart: {
        lines: [
          say('guard', '…3층에 올려다 놓으려다, 문이 잠겨 있어서 도로 가지고 내려왔습니다.'),
        ],
      },
      parcel: {
        lines: [
          say('guard', '3층 몫이요? …아침에 전달하려고 다른 데 뒀습니다.'),
          n('어디에 뒀는지는 말하지 않았다.'),
        ],
      },
      panel: {
        lines: [
          say('guard', '…오작동이 잦은 회로입니다. 시끄럽다는 민원이 있어서 밤에는 꺼 두곤 합니다.'),
          n('이력에 그 회로가 꺼진 밤은 어제 하루뿐이었다. 나는 그 말을 아껴 두었다.'),
        ],
      },
      dutyLog: {
        lines: [
          say('guard', '…전임자가 꼼꼼한 분이었지요. 저도 그 일지는 읽어 봤습니다.'),
          n('몇 번을 읽었는지는 묻지 않았다.'),
        ],
      },
      photo: {
        lines: [
          say('guard', '…………'),
          say('guard', '형사님이라면 찾아내실 줄 알았습니다. 그 얘기는, 다 모인 데서 하시지요.'),
        ],
      },
    },
    fallback: [say('guard', '글쎄요. 저는 경비라서 그런 건 잘 모릅니다.')],
  },
];

// Notebook entries that only appear once the player has learned of them.
export const EXTRAS = [
  {
    when: { clue: 'sua' },
    name: '이수아',
    age: 29,
    role: '박사과정 · 2년 전 사망',
    tag: '고인',
    desc: '2년 전 11월 17일, 412호 저온실에 갇혀 숨졌다. 학생실 창가의 빈 책상이 그녀의 자리였다.',
  },
];

// Each plays once, on the first move after the player holds that many clues.
export const EVENTS = [
  {
    id: 'call1',
    cluesAtLeast: 8,
    lines: [
      n('주머니에서 휴대폰이 떨었다. 박 반장이다.'),
      say('boss', '서 경위, 아직이야? 감식반은 철수했어. 손잡이 고장 난 방에 갇힌 사고야. 2년 전에 내가 맡았던 것도 똑같았다고.'),
      me('반장님, 좀 더 봐야 할 게 있습니다.'),
      say('boss', '보긴 뭘 봐. 여섯 시. 그 뒤로는 내 이름으로 올린다.'),
      n("전화가 끊겼다. 2년 전 그 사건을 '사고'로 닫은 사람이, 지금 내게 이 사건도 닫으라고 한다."),
    ],
  },
  {
    id: 'call2',
    cluesAtLeast: 18,
    lines: [
      n('다시 진동. 이번에는 모르는 번호다.'),
      say('dean', '화학과 학과장입니다. 형사님, 오늘 오전이 장 교수 취임식이었습니다. 총장님도 오시기로 돼 있었고요. 고인의 명예를 생각해서라도… 조용히, 빨리 정리해 주시면 좋겠습니다.'),
      n('고인의 명예. 2년 전에 죽은 학생의 명예를 걱정한 사람은 이 건물에 몇이나 있었을까.'),
      n('창밖은 아직 캄캄했다.'),
    ],
  },
];

export const DEDUCTION = {
  // Checked in order; the first missing clue decides which hint the player hears.
  required: [
    { clue: 'corpse', hint: '아직 현장도 제대로 보지 않았다. 저온실부터다.' },
    { clue: 'dryice', hint: '저온실 안쪽의 스티로폼 상자들. 아직 들여다보지 않았다.' },
    { clue: 'pin', hint: '문이 왜 안에서 열리지 않았는지 모른다. 저온실 안쪽 손잡이를 직접 봐야 한다.' },
    { clue: 'repair', hint: "손잡이가 '원래 고장'이었다는 말. 안전관리 담당자에게 확인해야 한다." },
    { clue: 'tempLog', hint: '저온실 문 옆의 온도 기록계. 아직 읽지 않았다.' },
    { clue: 'zoom', hint: '교수가 저온실에 들어가기 전에 무엇을 하고 있었는지 모른다. 교수실을 봐야 한다.' },
    { clue: 'invoice', hint: '연구실이 주문한 드라이아이스가 얼마인지 모른다. 실험실의 보관함.' },
    { clue: 'keys', hint: '실험실에는 복도로 통하는 뒷문이 있다. 아직 살펴보지 않았다.' },
    { clue: 'cctv', hint: '어젯밤 누가 드나들었는지, 경비실의 기록을 아직 받지 않았다.' },
    { clue: 'patrol', hint: '경비실의 순찰 기록을 아직 보지 않았다.' },
    { clue: 'guardWords', hint: '경비원에게 어젯밤 있었던 일을 아직 묻지 않았다.' },
    { clue: 'flower', hint: '학생실 창가의 빈 책상이 마음에 걸린다.' },
    { clue: 'sua', hint: '창가의 빈 책상. 그 자리의 주인이 누구였는지 물어봐야 한다.' },
    { clue: 'picket', hint: '2년 전 일을 민태오에게 아직 묻지 않았다.' },
    { clue: 'storeReceipt', hint: '이다인의 어젯밤 행적을 아직 묻지 않았다.' },
    { clue: 'nmr', hint: '민태오는 밤새 책상에 있었다고 했다. 기기실의 예약 시스템으로 확인할 수 있다.' },
    { clue: 'glovebox', hint: '권세린의 글러브박스 기록을 아직 확인하지 않았다.' },
    { clue: 'cart', hint: '오미경은 10시 반에 퇴근했다고 했다. 출입 기록은 다르게 말한다. 내밀어 봐야 한다.' },
    { clue: 'argument', hint: '어젯밤 연구실 분위기를 이다인에게 물어봐야겠다.' },
    { clue: 'trap', hint: '권세린은 교수와 다툰 일을 숨기고 있다. 들은 것을 내밀어야 한다.' },
    { clue: 'drawer', hint: '교수가 지키려던 서랍. 교수실에 있다.' },
    { clue: 'agno3', hint: '질산은이 어떤 물질인지 모른다. 설명해 줄 사람은 이다인이다.' },
    { clue: 'hands', hint: '덫이 누구를 잡았는지 확인해야 한다. 네 사람을 학생실에 모아 손끝을 살펴봐야 한다.' },
    { clue: 'parcel', hint: '이 넷이 아닌 누군가. 어젯밤 이 건물에 들어온 것을 처음부터 다시 봐야 한다. 경비실의 택배 대장.' },
    { clue: 'panel', hint: '내가 눌렀을 때 벨은 울렸다. 장 교수가 눌렀을 때는 왜 울리지 않았나. 경비실의 방재 패널.' },
    { clue: 'dutyLog', hint: '2년 전 그 밤, 경비실에는 무엇이 남아 있을까. 책꽂이의 근무일지.' },
    { clue: 'photo', hint: '누가 왜 이런 일을 했는지, 아직 끈이 이어지지 않는다. 경비실 책상을 다시 봐야 한다.' },
  ],
  opening: [
    n('새벽 5시 40분. 창밖은 아직 어둡다. 나는 모두를 1층 로비에 불러 모았다.'),
    n('민태오, 권세린, 오미경, 이다인. 그리고 경비실 문 앞에 선 이만석.'),
    n('휴대폰 화면에 박 반장의 메시지가 떠 있다. 「20분 남았다.」'),
    me('장현국 교수는 사고로 죽지 않았습니다.'),
  ],
  wrong: [
    n('…아니다. 이건 지금 내밀 패가 아니다.'),
    n('사람들의 눈빛이 흔들렸다. 내 말의 무게가 조금 가벼워졌다.'),
  ],
  steps: [
    {
      type: 'evidence',
      label: "'원래 고장'이라는 말을 깨는 증거를 제시하라",
      prompt: [say('serin', '사고가 아니라니요. 그 방 손잡이는 원래 고장이었잖아요. 2년 전에도…')],
      accept: ['repair', 'pin'],
      near: {
        dryice: [n("금지된 물건이 들어와 있었다. 맞다. 하지만 '원래 고장'이라는 말부터 깨야 한다.")],
        corpse: [n('긁힌 자국은 장 교수가 갇혔다는 것만 말해 준다. 왜 열리지 않았는지를 짚어야 한다.')],
        bell: [n("그것도 사고가 아니라는 근거다. 하지만 지금은 '원래 고장'이라는 말부터 깨야 한다.")],
        tempLog: [n("그것도 사고가 아니라는 근거다. 하지만 지금은 '원래 고장'이라는 말부터 깨야 한다.")],
        invoice: [n("그것도 사고가 아니라는 근거다. 하지만 지금은 '원래 고장'이라는 말부터 깨야 한다.")],
        parcel: [n("그것도 사고가 아니라는 근거다. 하지만 지금은 '원래 고장'이라는 말부터 깨야 한다.")],
        panel: [n("그것도 사고가 아니라는 근거다. 하지만 지금은 '원래 고장'이라는 말부터 깨야 한다.")],
      },
      success: [
        me('원래 고장이 아닙니다. 그 손잡이는 3주 전에 통째로 교체됐습니다. 오미경 씨가 안에서 열 번을 밀어 열 번 다 열렸죠.'),
        me('그런데 어젯밤에는 손잡이와 걸쇠를 잇는 핀이 빠져 있었습니다. 핀 자리에는 구멍만 남았습니다. 3주 전에 열 번을 밀어 열 번 열린 손잡이가 저절로 그렇게 되지는 않습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '드라이아이스가 저온실에 들어온 시각을 알려 주는 것을 제시하라',
      prompt: [say('taeo', '그럼… 누가 교수님을 가뒀다는 거예요? 언제요?')],
      accept: ['tempLog'],
      near: {
        dryice: [n('상자는 흉기다. 그것이 언제 들어왔는지를 알려 주는 기록이 있다.')],
        zoom: [n('23시 40분까지 장 교수가 살아 있었다는 것은 맞다. 그 전에 누군가 저온실에 들어갔다는 기록이 필요하다.')],
        parcel: [n('19시 40분은 상자가 이 건물에 들어온 시각이다. 저온실에 들어간 시각은 따로 있다.')],
        cart: [n('그 시각도 맞물린다. 하지만 지금 필요한 것은 저온실 문이 언제 열렸느냐다.')],
        panel: [n('그 시각도 맞물린다. 하지만 지금 필요한 것은 저온실 문이 언제 열렸느냐다.')],
      },
      success: [
        me('저온실 문 옆의 온도 기록입니다. 23시 27분에 문이 한 번 열렸고, 그 직후부터 방의 온도가 설정값 아래로 떨어집니다. 영하 78도짜리 드라이아이스 세 상자가 그때 들어온 겁니다.'),
        me('장 교수는 그 시각 교수실에서 화상 회의 중이었습니다. 23시 51분, 장 교수는 평소처럼 시료를 넣으러 들어갔고, 문이 닫혔고, 손잡이는 헛돌았습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '연구실 네 사람이 범인이 아니라는 증거를 제시하라',
      prompt: [
        say('mikyung', '그 시간에 연구실에 드나들 수 있는 건 우리뿐이에요. 그럼 우리 중에…'),
        n('네 사람이 서로를 봤다.'),
      ],
      accept: ['hands'],
      near: {
        nmr: [n('한 사람의 알리바이일 뿐이다. 네 사람을 한꺼번에 지우는 것이 있다.')],
        glovebox: [n('한 사람의 알리바이일 뿐이다. 네 사람을 한꺼번에 지우는 것이 있다.')],
        storeReceipt: [n('한 사람의 알리바이일 뿐이다. 네 사람을 한꺼번에 지우는 것이 있다.')],
        cctv: [n('복도 카메라는 412호 정문과 414호 문만 본다. 뒷문으로 드나든 사람까지 지워 주지는 못한다.')],
        trap: [n('덫 이야기는 맞다. 그 덫이 누구를 잡지 못했는지를 말해야 한다.')],
        agno3: [n('덫 이야기는 맞다. 그 덫이 누구를 잡지 못했는지를 말해야 한다.')],
        drawer: [n('덫 이야기는 맞다. 그 덫이 누구를 잡지 못했는지를 말해야 한다.')],
      },
      success: [
        me('장 교수는 서랍 속 연구노트 표지에 질산은을 발라 두었습니다. 그 노트가 어젯밤 사라졌습니다. 맨손으로 만졌다면 지금쯤 손끝이 검게 변해 있을 겁니다.'),
        me('새벽에 저는 네 분의 손을 확인했습니다. 지금 한 번 더 보여 주세요.'),
        n('로비의 형광등 아래 여덟 개의 손이 펼쳐졌다. 여전히 깨끗하다.'),
        me('손만이 아닙니다. 드라이아이스가 들어온 23시 27분, 민태오 씨는 지하 측정실에서 시료를 갈아 끼우고 있었고, 권세린 씨는 복도 카메라가 지켜보는 414호 안에 있었습니다.'),
        me('이다인 씨는 정문 편의점으로 가는 길이었고, 오미경 씨의 차는 그 3분 전에 주차장을 빠져나갔습니다. 기계와 영수증이 증언합니다.'),
      ],
    },
    {
      type: 'culprit',
      label: '범인을 지목하라',
      candidates: ['victim', 'dain', 'taeo', 'serin', 'mikyung', 'guard'],
      prompt: [
        say('mikyung', '우리가 아니면… 그럼 누가요?'),
        me('3주 전 손잡이를 교체한 시설팀 기사는 이번 주 내내 대전에 파견 가 있습니다. 그 사람도 아닙니다.'),
        me('남는 길은 하나입니다. 실험실 뒷문. 카드 리더도 없고 카메라에도 잡히지 않는 문입니다. 그 문의 열쇠는 세 벌입니다.'),
      ],
      accept: ['guard'],
      rebuttal: {
        victim: [
          n('장 교수가 제 손으로 핀을 빼고 드라이아이스를 들였다는 말이 된다. 23시 27분에 장 교수는 화상 회의 화면 앞에 앉아 있었다.'),
        ],
        taeo: [
          say('dain', '태오 선배는 그 시간에 지하에 있었잖아요. 형사님이 직접 기록을 찾으셨는데…'),
          n('맞다. 민태오의 손은 깨끗했고, 기계가 그의 두 시간을 증언한다.'),
        ],
        serin: [
          say('serin', '제 손을 보셨잖아요. 글러브박스 기록도요.'),
          n('맞다. 권세린은 덫이 있다는 것을 내게 알려 준 사람이다.'),
        ],
        mikyung: [
          say('mikyung', '나는 23시 19분에 나갔어요. 카메라에 다 찍혔다면서요.'),
          n('맞다. 뒷문 열쇠를 가진 사람이지만, 23시 24분에 오미경의 차는 주차장을 빠져나갔다.'),
        ],
        dain: [
          say('dain', '저, 저는 편의점에… 영수증 드렸잖아요.'),
          n('맞다. 성이 같다고 가족인 것은 아니다. 23시 34분의 영수증은 거짓말을 하지 않는다.'),
        ],
      },
      success: [
        me('이만석 씨. 당신입니다.'),
        n('로비가 조용해졌다. 이만석은 놀라지 않았다. 흰 장갑을 낀 두 손을 앞으로 모으고 서 있을 뿐이었다.'),
        say('guard', '…저는 경비입니다, 형사님. 순찰을 돌았을 뿐입니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '이만석이 드라이아이스를 4층으로 가져갔다는 증거를 제시하라',
      prompt: [],
      accept: ['parcel', 'cart'],
      near: {
        invoice: [n('연구실이 주문한 것은 한 박스. 맞다. 그럼 나머지 두 박스가 어디서 왔는지를 대야 한다.')],
        dryice: [n('세 상자가 거기 있었다는 것. 맞다. 그럼 그것이 어디서 왔는지를 대야 한다.')],
        guardWords: [n('이만석의 말은 뒤집을 대상이다. 먼저 상자가 어디서 왔는지를 대야 한다.')],
      },
      success: [
        me('어제 19시 40분, 드라이아이스 세 박스가 경비실에 들어왔습니다. 택배 수령 대장에는 412호 몫이 하나, 3층 몫이 둘. 3층 몫은 「익일 전달」이라고 적혀 있습니다.'),
        me('그런데 그 두 박스는 지금 경비실에 없습니다. 23시 20분, 오미경 씨가 로비에서 봤습니다. 손수레에 스티로폼 상자 두 개를 싣고 화물 엘리베이터 앞에 선 당신을.'),
        me('7분 뒤인 23시 27분, 저온실 문이 열렸습니다. 그 방에서 나온 상자는 셋입니다. 3층 몫 둘, 그리고 실험실 보관함에서 사라진 412호 몫 하나.'),
        say('guard', '…3층 문이 잠겨 있어서, 임시로 찬 곳에 넣어 둔 겁니다. 뚜껑이 열린 건 모르는 일입니다.'),
        me('새벽에는 저녁에 한 박스를 올려 준 것이 전부라고 하셨습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '비상벨이 울리지 않은 이유를 제시하라',
      prompt: [n('말이 바뀌었다. 하지만 말은 또 바꿀 수 있다. 바꿀 수 없는 기록이 하나 있다.')],
      accept: ['panel'],
      near: {
        bell: [n('벨이 멀쩡하다는 것은 내가 몸으로 확인했다. 그 벨이 어젯밤 왜 잠잠했는지를 보여 주는 기록이 있다.')],
      },
      success: [
        me('방재 패널 이력. 23시 16분, 412호 저온실 경보 회로 차단. 01시 44분 복구. 시신이 발견되고 4분 뒤입니다.'),
        me('그 패널은 경비실 안에 있고, 조작 열쇠는 당직 근무자가 갖고 다닙니다. 23시 16분에 장 교수는 화상 회의 중이었습니다. 장 교수가 꺼 달라고 부탁했을 리도 없죠.'),
        me('장 교수는 그 안에서 버튼에 피가 묻도록 벨을 눌렀습니다. 그 신호가 갈 길을, 당신이 미리 끊어 놓았습니다.'),
        say('guard', '…오작동이 잦은 회로라서 꺼 둔 겁니다.'),
        me('이력을 한 달 치 넘겨 봤습니다. 그 회로가 꺼진 밤은 어제 하루뿐입니다.'),
        n('이만석의 눈가가 처음으로 떨렸다.'),
      ],
    },
    {
      type: 'evidence',
      label: '이만석과 2년 전 사건을 잇는 것을 제시하라',
      prompt: [say('dain', '경비 아저씨가 왜요…? 교수님이랑은 말 한마디 섞을 일도 없는 분인데.')],
      accept: ['photo'],
      near: {
        flower: [n('2년 전 그 일과 이 사람을 잇는 끈이 필요하다.')],
        sua: [n('2년 전 그 일과 이 사람을 잇는 끈이 필요하다.')],
        picket: [n('2년 전 그 일과 이 사람을 잇는 끈이 필요하다.')],
        paper: [n('2년 전 그 일과 이 사람을 잇는 끈이 필요하다.')],
        dutyLog: [n('그 밤의 기록이다. 하지만 먼저 이 사람이 왜 그 밤을 붙들고 있는지를 보여야 한다.')],
        guardWords: [n("'냉동굴'. 귀에 걸리는 말이었다. 하지만 말보다 단단한 것이 있다.")],
      },
      success: [
        me('경비실 책상 유리 밑에 뒤집어 끼워 둔 사진입니다. 뒷면에 이렇게 적혀 있습니다. 「수아 석사 졸업. 아빠랑.」'),
        me('2년 전 11월 17일, 같은 저온실에서 숨진 이수아 씨. 당신 딸입니다.'),
        say('taeo', '…정문 앞에, 피켓 들고 서 계시던…'),
        n('민태오가 말을 잇지 못했다. 석 달 동안 고개를 숙이고 그 앞을 지나다녔다던 사람이다.'),
        me("새벽에 당신은 그 방을 '냉동굴'이라고 불렀습니다."),
        say('dain', '…그건 수아 선배가 지은 이름인데요. 연구실 사람들만 쓰는.'),
        say('guard', '…딸을 잃은 아비가 다 사람을 죽입니까, 형사님. 사고였다고, 2년 전에 경찰이 그랬습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '2년 전 그 밤, 저온실 앞에서 있었던 일을 보여 주는 것을 제시하라',
      prompt: [n('사고였다면 이만석에게는 장 교수를 죽일 까닭이 없다.')],
      accept: ['dutyLog'],
      near: {
        sua: [n('그 밤에 무슨 일이 있었는지를 그 자리에서 적어 둔 기록이 필요하다.')],
        picket: [n('그 밤에 무슨 일이 있었는지를 그 자리에서 적어 둔 기록이 필요하다.')],
        paper: [n('그 밤에 무슨 일이 있었는지를 그 자리에서 적어 둔 기록이 필요하다.')],
        photo: [n('사진은 이미 내밀었다. 그 밤에 무슨 일이 있었는지를 그 자리에서 적어 둔 기록이 필요하다.')],
      },
      success: [
        me('2년 전 11월 17일 밤, 그날 당직이던 전임 경비원의 근무일지입니다.'),
        me('23시 38분, 412호 저온실 비상벨. 23시 40분, 누군가 저온실 문 옆의 정지 단추로 벨을 껐습니다. 23시 41분, 장현국 교수가 경비실에 전화합니다. 「오작동입니다. 이상 없습니다.」 23시 55분, 장 교수 퇴근.'),
        me('이수아 씨는 다음 날 아침 여덟 시에 발견됐습니다.'),
        say('mikyung', '…벨이, 울렸다고요? 그날 밤에? 나는 2년 동안 그 애가 벨도 못 누르고 간 줄 알았어요.'),
        me('이만석 씨. 당신은 경비실에 앉아서 이 일지를 읽었습니다. 그 쪽만 귀퉁이가 닳도록.'),
        say('guard', '…일지 한 권, 사진 한 장으로 사람을 죽였다고 하실 수는 없습니다, 형사님.'),
      ],
    },
    {
      type: 'choice',
      label: '마지막으로, 이만석에게 무엇을 요구할 것인가',
      prompt: [
        n('맞는 말이다. 상자를 넣었다는 데까지는 이만석도 인정했다. 하지만 교수실 서랍에 손을 댔다는 물증은 아직 없다.'),
        n('있다면, 그것은 내가 아니라 이만석이 갖고 있다.'),
      ],
      options: [
        { id: 'locker', label: '사물함을 열어 달라고 한다' },
        { id: 'alibi', label: '자정 순찰의 행적을 다시 묻는다' },
        { id: 'gloves', label: '장갑을 벗어 달라고 한다' },
        { id: 'confess', label: '자백하라고 다그친다' },
      ],
      accept: ['gloves'],
      rebuttal: {
        locker: [
          say('guard', '영장이 있으십니까, 형사님.'),
          n('없다. 여섯 시까지 받아 올 수도 없다.'),
        ],
        alibi: [
          say('guard', '말씀드렸습니다. 층마다 태그를 찍었고, 기록에 다 남아 있습니다.'),
          n('기록은 이만석의 편이다. 다른 것을 봐야 한다.'),
        ],
        confess: [
          say('guard', '제가 무엇을 자백해야 합니까.'),
          n('이만석은 흔들리지 않는다. 말이 아니라 물증이 필요하다.'),
        ],
      },
      success: [
        me('이만석 씨. 장갑을 벗어 주시겠어요.'),
      ],
    },
  ],
};

export const ENDINGS = {
  true: {
    title: '승화',
    lines: [
      n('이만석은 한참 나를 바라봤다. 그러다 천천히, 오른손 장갑부터 벗었다.'),
      n('엄지와 검지, 중지의 끝이 먹물에 담갔다 뺀 것처럼 검었다.'),
      me('새벽 2시 20분, 현관에서 제게 명부를 내밀던 손은 깨끗했습니다. 저온실에서 저를 끌어냈을 때부터 당신은 줄곧 장갑을 끼고 있었죠.'),
      me('질산은은 몇 시간이 지나야 드러납니다. 씻어도 지워지지 않고요. 수아 씨의 노트를 꺼낸 사람은 당신입니다.'),
      say('guard', '…교수가 약을 발라 놨다는 건 몰랐습니다. 화학은, 우리 딸이 하던 거라서요.'),
      say('guard', '어제가 꼭 2년 되는 날이었습니다. 수아가 그 안에서 벨을 눌렀을 때, 장 교수는 문 앞까지 왔습니다. 창으로 우리 애와 눈이 마주쳤어요. 그러고는 벨을 끄고, 경비실에 「오작동입니다, 이상 없습니다」 하고는 퇴근했습니다.'),
      say('guard', '전송 안 된 문자가 딸아이 전화기에 남아 있었습니다. 「교수님 오셨어. 금방 열어 주실 거야.」 5분 뒤에. 「아빠, 안 열어 줘.」'),
      say('guard', '경찰서에 들고 갔습니다. 학교에도 갔고요. 정문 앞에 석 달을 서 있었습니다. 숨이 모자란 애가 헛것을 본 거라고 하더군요.'),
      say('guard', '그래서 이 건물에 들어왔습니다. 1년 반 동안 밤마다 증거를 찾았습니다. 전임자의 근무일지에 그 사람이 한 말이 그대로 적혀 있었습니다. 수아의 노트는 그 사람 서랍 맨 밑에 있었고요.'),
      say('guard', '노트 마지막 장에 우리 애 글씨가 있습니다. 「교수님이 수치를 올려 쓰자고 하심. 못 한다고 말씀드림.」 11월 15일입니다. 이틀 뒤에 그 문이 닫혔습니다.'),
      say('guard', '그 사람은 오늘 우리 애 실험으로 석좌교수가 될 참이었습니다. 그 자리에 오르고 나면 우리 애 글씨를 그냥 둘 리 없었습니다.'),
      me('자정 순찰 때, 4층에서 9분을 계셨죠.'),
      say('guard', '문 앞에 서 있었습니다. 그 사람이 2년 전에 서 있던 자리에. 안에서 두드리는 소리가 났어요. …우리 애도 저렇게 두드렸겠구나 했습니다.'),
      say('guard', '학생이 한 명이라도 그 방 근처에 있었으면 그만뒀을 겁니다. 1년 반을 기다렸는데 하루를 더 못 기다리겠습니까.'),
      n('이만석은 경비실 사물함에서 낡은 실험 노트 한 권을 꺼내 두 손으로 내밀었다. 표지에는 견출지가 떨어져 나간 자국. 첫 장에 「LSA-07 이수아」.'),
      say('guard', '이건 형사님이 가져가세요. 그 논문이 누구 것인지, 원래 숫자가 얼마였는지 다 적혀 있습니다. …2년 전에 형사님 같은 분이 왔더라면 좋았을 텐데요.'),
      n('나는 맨손으로 노트를 받았다. 내 손끝도 2주는 검을 것이다.'),
      n('권세린이 벽에 기대 주저앉았다. 이다인은 울고 있었다.'),
      n('여섯 시 정각, 박 반장에게 전화를 걸었다.'),
      me('반장님. 사고사 아닙니다. 피의자 확보했습니다. 그리고 2년 전 이수아 사건, 재수사 올리겠습니다.'),
      say('boss', '…서 경위. 그거 내가 닫은 사건이야.'),
      me('압니다. 그래서 제가 엽니다.'),
      n('창밖은 아직 어두웠다. 저온실의 드라이아이스는 해가 뜰 무렵이면 흔적도 없이 사라져 있을 것이다. 녹지도 않고, 얼음에서 곧장 기체가 되어. 화학에서는 그것을 승화라고 부른다.'),
      n('하지만 사라지지 않는 것도 있다. 검게 물든 손끝처럼, 시간이 지나야 비로소 드러나는 것이.'),
    ],
    epilogue: '이만석은 체포됐고, 이수아 사건은 2년 만에 다시 열렸다. 넉 달 뒤, 그 논문의 제1저자는 「故 이수아」로 정정됐다.',
  },
  bad: {
    title: '사고사',
    lines: [
      n('말이 꼬였다. 내 추리의 빈틈으로 사람들의 의심이 밀려들었다.'),
      n('여섯 시 정각, 휴대폰이 울렸다.'),
      say('boss', '시간 됐다, 서 경위. 사고사로 올린다. 수고했어.'),
      n('장현국 교수의 죽음은 안전수칙 미준수에 의한 사고로 종결됐다. 오전 열한 시의 취임식은 추도식으로 바뀌었다.'),
      n('한 달 뒤, 12월 17일. 나는 이유 없이 412호에 들렀다.'),
      n('창가의 빈 책상에, 흰 국화 한 송이가 놓여 있었다.'),
    ],
    epilogue: '사건은 사고사로 묻혔다. 하지만 단서는 아직 당신의 수첩에 남아 있다.',
    retry: 'deduce',
  },
};
